import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchDistributorCurrentStock = createAsyncThunk("fetchDistributorCurrentStock", async ({ page, limit, filters }) => {
	const params = new URLSearchParams({
		page: page || 1,
		limit: limit || 10,
		sku: filters?.sku?.trim() || "",
		distributor_name: filters?.distributor_name?.trim() || "",
		distributor_code: filters?.distributor_code?.trim() || "",
	});

	const response = await axiosHttp.get(`distributor/stock/current?${params}`);
	return response.data;
});

const DistributorCurrentStockSlice = createSlice({
	name: "DistributorCurrentStockSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		total: 0,
		page: 1,
		limit: 10,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchDistributorCurrentStock.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchDistributorCurrentStock.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload?.data;
			state.total = action.payload.pagination?.totalRecords || 0;
			state.page = action.payload.pagination.currentPage || 1;
		});
		builder.addCase(fetchDistributorCurrentStock.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload.data;
		});
	},
});

export default DistributorCurrentStockSlice.reducer;
